import { render } from "./collected.vue?vue&type=template&id=176e32fe"
import script from "./collected.vue?vue&type=script&lang=js"
export * from "./collected.vue?vue&type=script&lang=js"

import "./collected.vue?vue&type=style&index=0&id=176e32fe&lang=css"

import exportComponent from "/root/.jenkins/workspace/hidoc/hidoc-web/03_SRC/hidoc-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__